/**
 * Trunnion AI - Keyboard Shortcuts Settings
 * Displays all registered shortcuts.
 */

import { SHORTCUTS } from '@/config/shortcuts';
import { formatShortcut } from '@/hooks/useHotkeys';
import { Card } from '@/components/ui/Card';

export function KeyboardShortcutsSettings() {
  const globalShortcuts = SHORTCUTS.filter((s) => s.scope === 'global');
  const designerShortcuts = SHORTCUTS.filter((s) => s.scope === 'designer');
  const chatShortcuts = SHORTCUTS.filter((s) => s.scope === 'chat');

  return (
    <div className="space-y-6">
      <ShortcutSection title="Global" shortcuts={globalShortcuts} />
      <ShortcutSection title="Workflow Designer" shortcuts={designerShortcuts} />
      {chatShortcuts.length > 0 && (
        <ShortcutSection title="Agent Chat" shortcuts={chatShortcuts} />
      )}
    </div>
  );
}

function ShortcutSection({
  title,
  shortcuts,
}: {
  title: string;
  shortcuts: typeof SHORTCUTS;
}) {
  return (
    <Card>
      <div className="p-6">
        <h3 className="text-lg font-semibold text-white mb-4">{title}</h3>
        <div className="space-y-3">
          {shortcuts.map((shortcut) => (
            <div
              key={shortcut.id}
              className="flex items-center justify-between py-1"
            >
              <div>
                <p className="text-sm text-white">{shortcut.label}</p>
                <p className="text-xs text-trunnion-slate-500">
                  {shortcut.description}
                </p>
              </div>
              <kbd className="flex items-center gap-1 rounded-lg border border-trunnion-slate-600 bg-trunnion-slate-800 px-2.5 py-1.5 text-xs font-mono text-trunnion-slate-300">
                {formatShortcut(shortcut.keys)}
              </kbd>
            </div>
          ))}
        </div>
      </div>
    </Card>
  );
}
